import { createComputerMenuPresentation } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/computerMenuModel.js';
import { useEffect, useMemo, useRef } from 'react';
export function useComputerMenuSearchPresentation({ catalog, search, }) {
    const { liveQuery, resolvedQuery, isLoading, isPlaceholderData, isFetching } = search;
    const presentationQueryRef = useRef(liveQuery);
    const lastConfirmedQueryRef = useRef(null);
    const isDirty = resolvedQuery !== liveQuery || isLoading || isPlaceholderData;
    const isPending = isDirty || isFetching;
    const livePresentation = useMemo(() => createComputerMenuPresentation(catalog, {
        query: liveQuery,
        serverSearchSource: 'locally-filtered',
    }), [catalog, liveQuery]);
    const presentationQuery = !isDirty || livePresentation.orderedItems.length > 0 ? liveQuery : presentationQueryRef.current;
    useEffect(() => {
        presentationQueryRef.current = presentationQuery;
        if (!isDirty) {
            lastConfirmedQueryRef.current = liveQuery;
        }
    }, [isDirty, liveQuery, presentationQuery]);
    const presentation = useMemo(() => createComputerMenuPresentation(catalog, {
        query: presentationQuery,
        serverSearchSource: isDirty ? 'locally-filtered' : 'server-authoritative',
    }), [catalog, isDirty, presentationQuery]);
    const emptyState = getEmptyState({
        hasItems: presentation.orderedItems.length > 0,
        isDirty,
        isPresentingLastConfirmedQuery: presentationQuery === lastConfirmedQueryRef.current,
    });
    return {
        ...presentation,
        status: isPending ? 'pending' : 'settled',
        emptyState,
    };
}
function getEmptyState({ hasItems, isDirty, isPresentingLastConfirmedQuery, }) {
    if (hasItems)
        return 'none';
    if (!isDirty)
        return 'confirmed';
    return isPresentingLastConfirmedQuery ? 'pending' : 'none';
}
//# sourceMappingURL=useComputerMenuSearchPresentation.js.map